module.exports = __webpack_public_path__ + "img/businessseat.ad5a22ef.jpg";